export default {
  'SET_COLLECTIONS'(state, data) {
    state.collections = data;
  },
  'SET_REQUESTS'(state, data) {
    state.requests = data;
  },
  'ADD_REQUEST'(state, data) {
    const { collection_id: collectionId } = data;
    state.requests.push(data);

    state.collections = state.collections.map(item => {
      if (parseInt(item.id, 10) === parseInt(collectionId, 10)) {
        const pushed = item.requests;
        pushed.push(data);
        return {
          ...item,
          requests: pushed
        };
      }

      return item;
    });
  },
  'SET_ALLOWED_METHODS'(state, data) {
    state.allowedMethods = data;
  },
  'SET_REQUEST_STATE'(state, data) {
    state.requestState = parseInt(data, 10);
  },
  'SET_RESPONSE'(state, data) {
    state.response = data;
  },
  'SET_REQUEST_START_TIME'(state, data) {
    state.requestStartTime = parseInt(data, 10);
  },
  'SET_REQUEST_END_TIME'(state, data) {
    state.requestEndTime = parseInt(data, 10);
  }
};